import styles from "./TypeaheadDirectSearch.module.scss";
import MiscellaneousSearch from "../../../../common/icons/MiscellaneousSearch.tsx";
import { FormattedMessage } from "react-intl";

export default function TypeaheadDirectSearch({
  type,
  term,
}: {
  term: string;
  type: string;
}) {
  return (
    <>
      <MiscellaneousSearch />

      <div>
        {type === "titles" ? (
          <FormattedMessage
            defaultMessage="{term} - <span>in all titles</span>"
            values={{
              term,
              span: (chunks) => (
                <span className={styles.subtitle}>{chunks}</span>
              ),
            }}
          />
        ) : (
          <FormattedMessage
            defaultMessage="{term} - <span>inside my books</span>"
            values={{
              term,
              span: (chunks) => (
                <span className={styles.subtitle}>{chunks}</span>
              ),
            }}
          />
        )}
      </div>
    </>
  );
}
